import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(() => ({
	addArea: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		flexDirection: 'column',
		height: 250,
		width: '100%',
		border: '2px dashed #ccc',
		borderRadius: 4,
		color: '#ccc',
		cursor: 'pointer',
		transition: '.2s',
		marginBottom: '1em',
		'& svg': {
			fill: '#ccc',
		},
		'&:hover': {
			color: '#000',
			border: '2px dashed #000',
			transition: '.2s',
			'& svg': {
				fill: '#000',
			},
		},
	},
}));

export default useStyles;
